export const premiumPlanIds = {
  dmp: "dmwdynadtc",
  dmx: "dmxwdynadtc",
};

export const planDescription = (productName) =>
  `Access to the full ${productName} experience: providing comprehensive and trusted clinical information anytime, anywhere.`;
export const premiumPlanDescription = (productName) =>
  `Experience the power of ${productName}, enhanced with <strong>Dyna AI</strong>, to deliver precise clinical answers to complex questions faster than ever through advanced search capabilities.`;

export const productBullets = {
  dmp: [
    "Robust coverage of 35+ medical specialties, updated multiple times daily",
    "Transparent evidence-based clinical content and patient resources, right at your fingertips",
    "Streamlined CME and MOC tracking and management",
  ],
  dmx: [
    "Robust coverage of 35+ medical specialties, updated multiple times daily",
    "Transparent evidence-based clinical content and patient resources, right at your fingertips",
    "Comprehensive adult, pediatric, and neonatal drug dosing, interaction, and compatibility information from Micromedex",
    "Streamlined CME and MOC tracking and management",
  ],
};
